import React from "react";
import styles from "./styles.module.scss";

export function HR1({ className = "" }) {
  return <hr className={`${styles.hr} ${className}`} />;
}
